import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_doc_permissions() {
    return <SiteDocumentation page="permissions"/>;
}
